import {
  AT_TYPE_ID_ABSENT,
  AT_TYPE_ID_ABSENT_EXCUSED,
  AT_TYPE_ID_OUT,
  AT_TYPE_ID_OUT_OF_BUILDING,
  AT_TYPE_ID_PRESENT,
  AT_TYPE_ID_TARDY,
  AT_TYPE_ID_TARDY_EXCUSED,
} from "redux/constants";

const periodWeekView = 'period_week_view_type_'

const classRootStructure = theme => ({
  periodRoot: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    position: 'absolute',
    zIndex: 1000
  },
  periodName: {
    display: 'inline-block',
    margin: 5,
    position: 'relative',
    zIndex: 1001
  },
  [`${periodWeekView}default`]: {
  },
  [`${periodWeekView}current`]: {
    background: '#f2f2f2',
    border: '1px solid',
    borderColor:'#ededed',
    opacity: 1
  },
  root: {
    padding: theme.spacing.unit * 2,
  },
  selectorRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing.unit * 2,
    minHeight: 40,
    marginBottom: theme.spacing.unit * 3,
    marginLeft: 0,
  },
  orText: {
    margin: `0 ${theme.spacing.unit * 2}px`,
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  orTextInVisible: {
    margin: `0 ${theme.spacing.unit * 2}px`,
    fontWeight: 500,
    visibility: 'hidden',
    pointerEvents: 'none',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
  },
  selector: {
    minWidth: 180,
    flex: '0 1 180px',
  },
  tableCellText: {
    fontSize: 14
  }
})

const styles = theme => {
  const classes = {...classRootStructure(theme)}
  for (let cssClassName in classes) if (cssClassName.startsWith(periodWeekView)) {
    classes[cssClassName] = Object.assign({},
      {
        cursor: 'pointer',
        background: '#d9d9d9',
        border: '1px solid',
        borderColor:'#E9E9E9',
        borderRadius: 0,
        width: '100%', height: '100%',
        opacity: 1,
        position: 'absolute',
      },
      classes[cssClassName]
    )
  }
  return classes
}

export const makePeriodClassName = (period) => {
  return period.isCurrent ? `${periodWeekView}current` : `${periodWeekView}default`
}

export const getAtTypeCellStyle = (atTypeId) => {
  switch (atTypeId) {
    case AT_TYPE_ID_TARDY:
      return { background: '#B3E5FC', fontWeight: 500 };
    case AT_TYPE_ID_PRESENT:
      return { background: '#C8E6C9', fontWeight: 500 };
    case AT_TYPE_ID_ABSENT:
      return { background: '#9f84ba', fontWeight: 500 };
    case AT_TYPE_ID_ABSENT_EXCUSED:
      return { background: '#c58efe', fontWeight: 500 };
    case AT_TYPE_ID_TARDY_EXCUSED:
      return { background: '#93defe', fontWeight: 500 };
    case AT_TYPE_ID_OUT_OF_BUILDING:
      return { background: '#fdd3c6', fontWeight: 500 };
    case AT_TYPE_ID_OUT:
      return { background: '#f3ebd8', fontWeight: 500 };
    default:
      return {};
  }
}

export const getAtTypeTextStyle = (atTypeId) => {
  switch (atTypeId) {
    case AT_TYPE_ID_TARDY:
      return { color: '#01579b' };
    case AT_TYPE_ID_TARDY_EXCUSED:
      return { color: '#01579b' };
    case AT_TYPE_ID_PRESENT:
      return { color: '#256029' };
    case AT_TYPE_ID_ABSENT:
      return { color: '#01213b' };
    case AT_TYPE_ID_ABSENT_EXCUSED:
      return { color: '#01213b' };
    case AT_TYPE_ID_OUT:
      return { color: '#a19f99' };
    default:
      return {};
  }
}

export default styles